import React, { useState } from "react";
import { darkToast, toast, ToastContainer } from "../../Components/Toast";
import ReactLoading from "react-loading";
import { useHistory } from "react-router";
import axios from "axios";
import { serverUrl } from "../../Utils/server";

export const AddBundle = () => {
  const history = useHistory();

  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0);
  const [stock, setStock] = useState(0);
  const [imageUrl, setImageUrl] = useState("");

  const [loading, setLoading] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);

  const uploadImage = async (image) => {
    if (!image) return;

    setUploadingImage(true);

    const formData = new FormData();
    formData.append("image", image);

    try {
      const response = await axios.post(`${serverUrl}/upload/image`, formData, {
        headers: {
          Authorization: `JWT ${localStorage.getItem("token")}`,
        },
      });

      const url =
        response?.data?.url ||
        response?.data?.image ||
        response?.data?.fileUrl ||
        response?.data?.downloadURL ||
        response?.data;

      if (!url || typeof url !== "string") {
        throw new Error("El backend no devolvió la URL de la imagen");
      }

      setImageUrl(url);
      toast("Imagen subida correctamente", darkToast);
    } catch (err) {
      const rawMsg = err?.response?.data;
      const backendMsg =
        typeof rawMsg === "object"
          ? rawMsg?.msg || rawMsg?.message || JSON.stringify(rawMsg)
          : rawMsg;

      toast(String(backendMsg || err?.message || "No se pudo subir la imagen"), darkToast);
    } finally {
      setUploadingImage(false);
    }
  };

  const upload = () => {
    if (title === "") {
      return toast("El título del paquete es obligatorio", darkToast);
    } else if (subtitle === "") {
      return toast("El subtítulo es obligatorio", darkToast);
    } else if (description === "") {
      return toast("La descripción es obligatoria", darkToast);
    } else if (price === "") {
      return toast("El precio es obligatorio", darkToast);
    } else if (stock === "") {
      return toast("La existencia es obligatoria", darkToast);
    } else if (imageUrl === "") {
      return toast("Sube una imagen", darkToast);
    }

    setLoading(true);

    const config = {
      method: "post",
      url: `${serverUrl}/bundles/add`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
      data: {
        title: title,
        subtitle: subtitle,
        description: description,
        price: parseInt(price),
        stock: parseInt(stock),
        image: imageUrl,
      },
    };

    axios(config)
      .then((response) => {
        if (response.status === 200) {
          toast("Paquete creado correctamente", darkToast);

          setTimeout(() => {
            history.push("/bundles");
            window.location.reload();
          }, 1000);
          setLoading(false);
        }
      })
      .catch((err) => {
        const rawMsg = err?.response?.data;
        const backendMsg =
          typeof rawMsg === "object"
            ? rawMsg?.msg || rawMsg?.message || JSON.stringify(rawMsg)
            : rawMsg;

        toast(String(backendMsg || "No se pudo crear el paquete"), darkToast);
        setLoading(false);
      });
  };

  return (
    <div className="content-body">
      <div className="content-title">
        <p>Añadir nuevo paquete</p>
      </div>
      <div className="form">
        <p>Título del paquete</p>
        <input
          type="text"
          placeholder="Título del paquete"
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />

        <p>Subtítulo</p>
        <input
          type="text"
          placeholder="Subtítulo"
          onChange={(e) => {
            setSubtitle(e.target.value);
          }}
        />

        <p>Descripción</p>
        <input
          type="text"
          placeholder="Descripción"
          onChange={(e) => {
            setDescription(e.target.value);
          }}
        />

        <p>Precio</p>
        <input
          type="number"
          placeholder="Precio"
          onChange={(e) => {
            setPrice(e.target.value);
          }}
        />

        <p>Existencia</p>
        <input
          type="number"
          placeholder="Existencia"
          onChange={(e) => {
            setStock(e.target.value);
          }}
        />

        <p>Imagen</p>
        {uploadingImage ? (
          <div style={{ margin: "1rem" }}>
            <ReactLoading
              type={"spinningBubbles"}
              color={"var(--primaryColor)"}
              width={"2rem"}
              height={"2rem"}
            />
          </div>
        ) : imageUrl !== "" ? (
          <img
            style={{
              width: "20%",
              margin: "1rem",
              objectFit: "contain",
            }}
            src={imageUrl}
            alt=""
          />
        ) : null}

        <input
          type="file"
          onChange={(e) => {
            uploadImage(e.target.files[0]);
          }}
        />

        <button
          className={loading || uploadingImage ? "disabled" : ""}
          onClick={() => {
            upload();
          }}
        >
          {loading ? (
            <ReactLoading
              type={"spinningBubbles"}
              color={"white"}
              width={"1.2rem"}
              height={"1.2rem"}
            />
          ) : (
            "Añadir paquete"
          )}
        </button>
      </div>
      <ToastContainer />
    </div>
  );
};
